import { render, staticRenderFns } from "./AdvertiseContainer.vue?vue&type=template&id=94951e1c&"
import script from "./AdvertiseContainer.vue?vue&type=script&lang=js&"
export * from "./AdvertiseContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports